<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="companies"
      :items="companies"
      :fields="companiesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedCompanies"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      companiesFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedCompanies: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedCompanies = {
        id: 0,
        name: '',
        bank_id: 0,
        contract_number: '',
        contract_place: '',
        number_format: '',
        client_prefix: '',
        service_place: '',
        short_name: '',
        jur_adress: '',
        act_adress: '',
        inn: '',
        kpp: '',
        headman: '',
        bookeeper: '',
        short_headman: '',
        short_bookeeper: '',
        account: '',
        type: 0,
        tax_rate: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditCompanies', '#btnShow')
    },
    editItem (item) {
      this.selectedCompanies = item
      this.selectedCompanies.contract_number = ''
      this.selectedCompanies.contract_place = ''
      this.selectedCompanies.number_format = ''
      this.selectedCompanies.client_prefix = ''
      this.selectedCompanies.service_place = ''
      this.$root.$emit('bv::show::modal', 'modalEditCompanies', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Companies"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_COMPANIES', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_COMPANIES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    companies () {
      let com = []
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/COMPANIES']))
      for (let el of copy) {
        if (el.type === 0) {
          com.push(el)
        }
      }
      return com
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_COMPANIES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/companies/main.vue